import React, { useEffect, useState } from "react";
import { Form, Input, Button, Link } from "@heroui/react";
import { InputOtp } from "@heroui/react";
import axios from 'axios'
import toast from "react-hot-toast";
import { SERVER_URL } from "../../../Config";
import { useNavigate } from "react-router-dom";

export default function Register() {
  const [submitted, setSubmitted] = React.useState(null);
  const [errors, setErrors] = React.useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [value, setValue] = React.useState("");
  const [values, setValues] = React.useState("");
  const [selectedCountry, setSelectedCountry] = useState('');

  const navigate = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault()
    if (value !== values) {
      toast.error('Pin and Confirm pins are not the same');
      setIsLoading(false);
      return false;
    }

    const formData = new FormData(e.currentTarget);
    const data = {};
    formData.forEach((value, key) => {
      data[key] = value;
    });

    data.secret_pin = value;

    setIsLoading(true);
    setErrors({});

    try {
      const res = await axios.post(`${SERVER_URL}/api/createUser`, data);
      if (res.data.status === true) {
        toast.success('Registration Completed Successfully');
        setTimeout(() => {
          navigate('/Login');
        }, 1000);
      } else {
        toast.error(res.data.message);
        setIsLoading(false);
        return false
      }
    } catch (error) {
      console.error('Error during registration:', error);
      toast.error('An error occurred while registering. Please try again.');
      setIsLoading(false);
      return false
    }
  };

  return (
    <div className=' bg-[#060606] h-screen overflow-hidden overflow-y-auto relative text-white '>
      <div className=' h-screen opacity-15 -translate-y-36 ' style={{
        background: "radial-gradient(50% 50% at 50% 50%, #FFF2C2 0%, rgba(0, 0, 0, 0) 100%)"
      }}></div>
      <div className='absolute top-[30%] left-0 right-0'>
        <div className='max-w-3xl w-full mx-auto h-96 opacity-40 -translate-y-20 ' style={{
          background: "radial-gradient(50% 50% at 50% 50%, rgba(255, 242, 194, 0.44) 0%, rgba(0, 0, 0, 0) 100%)"
        }}></div>
        <div className='flex justify-center absolute top-0 left-0 right-0 w-full '>
          <img src='../assets/other/dashboard1.svg' className='' />
          <img src='../assets/other/dashboard1.svg' className=' scale-x-[-1] ' />
        </div>
      </div>
      <div className=' absolute top-[50%] -translate-y-[50%] left-0 right-0 flex justify-center items-center '>
        <div className=" w-[95%] mx-auto z-30 max-w-md mt-10 mb-5 bg-gradient-to-b from-[#0B0F1047] to-[#241D1447] p-5 rounded-3xl border border-[#2F2F2F]  flex flex-col justify-center items-center font-poppins dark text-foreground ">
          <div className="flex items-center gap-2 mb-6 ">
            <img className="w-20 h-20" src="../assets/Logo/logo.svg" alt="Stabilix Logo" />
            <p className="font-bold text-2xl font-Artemus">STABILIX</p>
          </div>
          <Form
            className="w-full flex flex-col justify-center items-center space-y-4"
            validationBehavior="native"
            validationErrors={errors}
            onReset={() => setSubmitted(null)}
            onSubmit={onSubmit}
          >

            <div className="flex flex-col gap-4  w-[85%] mx-auto ">
              <div className="flex flex-col justify-start items-start w-full gap-2">
                <Input
                  isRequired
                  errorMessage={({ validationDetails }) => {
                    if (validationDetails.valueMissing) {
                      return "Please Enter AppID";
                    }
                  }}
                  label="App ID"
                  labelPlacement="outside"
                  name="AppID"
                  placeholder="AppID"
                  type="text"
                />
              </div>

              <div className="flex flex-col justify-start items-start w-full gap-2">
                <label className="text-sm font-medium text-white">
                  Secret Pin <span className="text-danger">*</span>
                </label>
                <InputOtp
                  isRequired
                  errorMessage={({ validationDetails }) => {
                    if (validationDetails.valueMissing) {
                      return "Please Enter Secret Pin";
                    }
                  }}
                  length={6}
                  value={value}
                  onValueChange={setValue}
                  type="password"
                  variant="bordered"
                  className="w-full"
                />
              </div>
              <div className="flex flex-col justify-start items-start w-full gap-2">
                <label className="text-sm font-medium text-white">
                  Confirm Secret Pin <span className="text-danger">*</span>
                </label>
                <InputOtp
                  isRequired
                  errorMessage={({ validationDetails }) => {
                    if (validationDetails.valueMissing) {
                      return "Please Enter Confirm Secret Pin";
                    }
                  }}
                  length={6}
                  value={values}
                  onValueChange={setValues}
                  type="password"
                  variant="bordered"
                  className="w-full"
                />
              </div>

              <Button color="danger" type="submit" isLoading={isLoading} className='w-full bg-gradient-to-br from-[#F6FFE9] to-[#94998C] p-0.5 rounded-full  '>
                <div className='w-full font-Artemus bg-gradient-to-r from-[#1A1B18] to-[#856E4F] rounded-full p-2'>
                  Register to Platform
                </div>
              </Button>
              <Button
                showAnchorIcon
                as={Link}
                color="foreground"
                href="/Login"
                variant="solid"
                className="text-white"

              >
                Click here for Login
              </Button>
              {/*
              <Input
                isRequired
                errorMessage={({ validationDetails }) => {
                  if (validationDetails.valueMissing) {
                    return "Please Enter Name";
                  }
                }}
                label="Name"
                labelPlacement="outside"
                name="Name"
                placeholder="Name"
                type="text"
              />

              <Input
                isRequired
                errorMessage={({ validationDetails }) => {
                  if (validationDetails.valueMissing) {
                    return "Please Enter Email";
                  }
                }}
                label="Email"
                labelPlacement="outside"
                name="Email"
                placeholder="Email"
                type="email"

              />

              <Select
                isRequired
                errorMessage={({ validationDetails }) => {
                  if (validationDetails.valueMissing) {
                    return "Please Choose Country";
                  }
                }}
                label="Country"
                labelPlacement="outside"
                name="Country"
                isSearchable={true}
                placeholder="Select Country"
                value={selectedCountry}
                onChange={handleCountryChange}
              >
                {countriesData.map((country) => (
                  <SelectItem key={country.iso2} value={country.iso2}>
                    {country.country}
                  </SelectItem>
                ))}
              </Select>

              <Input
                isRequired
                errorMessage={({ validationDetails }) => {
                  if (validationDetails.valueMissing) {
                    return "Please Enter Phone No";
                  }
                }}
                label="Phone"
                labelPlacement="outside"
                name="Phone"
                placeholder="Phone"
                type="tel"
              />

              <div className="flex flex-col justify-start items-start w-full gap-2">

                <select
                  className="border border-white/20 outline-none w-full mt-3 bg-transparent py-2 rounded-lg px-3 "
                  value={walletData.question_id}
                  onChange={(e) =>
                    setwalletData((prevData) => ({ ...prevData, question_id: e.target.value }))
                  }
                >
                  <option className="bg-black text-white rounded-lg" value="">Select a Security Question</option>
                  {questions.map((q) => (
                    <option className="bg-black text-white rounded-lg" key={q.id} value={q.id}>
                      {q.question}
                    </option>
                  ))}
                </select>

                <input
                  className="border border-white/20 outline-none w-full mt-3 bg-transparent py-2 rounded-lg px-3"
                  value={walletData.answer}
                  onChange={(e) => setwalletData((prevData) => ({ ...prevData, answer: e.target.value }))}
                  placeholder="Enter Answer to Security Question"
                />
              </div>

              <Checkbox
                isRequired
                classNames={{
                  label: "text-small",
                }}
                isInvalid={!!errors.terms}
                name="terms"
                validationBehavior="aria"
                value="true"
                onValueChange={() => setErrors((prev) => ({ ...prev, terms: undefined }))}
              >
                I agree to the terms and conditions
              </Checkbox>
              
              {errors.terms && <span className="text-danger text-small">{errors.terms}</span>}
              */}

            </div>
          </Form>

        </div>
      </div>
    </div>

  );
}
